import { Routes } from '@angular/router';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { isLeasingCompanyUserGuard } from '@shared/guards/leasing-company/leasing-company.guard';
import { AddService } from '@app/leasing-company/packs/add/services/add.service';
import { DetailsService } from '@app/leasing-company/packs/details/services/details.service';

export const packsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/leasing-company/packs/overview/overview.component').then(component => component.OverviewComponent),
    providers: [{ provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false } },],
  },
  {
    path: 'add',
    loadComponent: () => import('@app/leasing-company/packs/add/add.component').then(component => component.AddComponent),
    canActivate: [isLeasingCompanyUserGuard({ roles: ['LEASING_COMPANY_MANAGER', 'LEASING_COMPANY_WITH_AUTHORIZATION'] })],
    providers: [AddService],
  },
  {
    path: ':id',
    loadComponent: () => import('@app/leasing-company/packs/details/details.component').then(component => component.DetailsComponent),
    providers: [DetailsService],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
